import React from "react";
import { ArrowRightLeftIcon, PauseCircleIcon, Settings2Icon, UsersIcon, BoxIcon } from "lucide-react";
import { situations } from "../data/site";
const icons: Record<(typeof situations)[number]['icon'], BoxIcon> = {
  stuck: PauseCircleIcon,
  alignment: UsersIcon,
  operations: Settings2Icon,
  transition: ArrowRightLeftIcon
};
export function WhenToBringMeIn() {
  return <section id="when-to-bring-me-in" className="bg-sage border-y border-sage-line" data-id="element-106" data-mp="16bgoxnwluf22">
      <div className="max-w-content mx-auto px-5 sm:px-6 lg:px-10 py-20 md:py-24" data-id="element-107" data-mp="1693wuhx4uoba">
        <p className="text-xs sm:text-[0.8125rem] uppercase tracking-[0.14em] font-medium text-forest" data-id="element-108" data-mp="11c3rk983xpl8">
          When to bring me in
        </p>
        <h2 className="mt-4 font-serif text-3xl md:text-[2.5rem] leading-tight tracking-tight text-ink" data-id="element-109" data-mp="1b1natfzqflgm">
          You know something needs to change.
        </h2>

        <ul className="mt-12 grid sm:grid-cols-2 gap-x-12 gap-y-10 lg:gap-x-16" data-id="element-110" data-mp="1ozvb9xvz94wj">
          {situations.map(situation => {
          const Icon = icons[situation.icon];
          return <li key={situation.title} className="flex gap-5 pt-7 border-t border-sage-line" data-id="element-111" data-mp="17r4s3zbihh1">
                <Icon size={22} strokeWidth={1.5} aria-hidden="true" className="shrink-0 mt-1 text-forest" data-id="element-112" data-mp="589wzz54hpjr" />
                <div data-id="element-113" data-mp="a5jij3pe5h2b">
                  <h3 className="font-serif text-xl leading-snug text-ink" data-id="element-114" data-mp="a97dm7ahibj5">{situation.title}</h3>
                  <p className="mt-3 text-base leading-relaxed text-ink-soft" data-id="element-115" data-mp="f3l35t2gtofw">{situation.body}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}